import { acquisitionFailureDescriber } from '../acquisitionErrors';
import { CDQ_INELIGIBILITY_MESSAGE } from './cdqEligibility';

export const CDQ_GENERIC_FAILURE_MESSAGE =
  'Non è stato possibile acquisire la lead Cessione del quinto. I dati inseriti sono stati conservati: riprova.';

/**
 * Translates a refused CdQ acquisition into what the operator reads: the
 * shared classification of acquisition failures, spoken in this product's own
 * words and explained with this product's own qualification policy.
 */
export const describeCdqAcquisitionFailure = acquisitionFailureDescriber({
  leadLabel: 'Cessione del quinto',
  ineligibilityMessages: CDQ_INELIGIBILITY_MESSAGE,
  ineligibleFallback:
    'Il profilo del cliente non è idoneo per una Cessione del quinto e la lead non è stata acquisita.',
  genericFailure: CDQ_GENERIC_FAILURE_MESSAGE,
});
